/* Relatorios (admin/owner). */
import { slaReport, type SlaReport } from "@zapir/shared";
import { request } from "./core";

export const reportsApi = {
  async reportsSla(params: { from: string; to: string }): Promise<SlaReport> {
    return request("/reports/sla", { query: params, schema: slaReport });
  },
};
